import { addCopilotFiles as e, uploadAllCopilotFiles as t, uploadCopilotFile as n, validateFile as r } from "../file-upload.js";
import { useCallback as i } from "react";
import { useStore as a } from "@nanostores/react";
//#region src/react/file-upload.ts
function o(o) {
	return {
		files: a(o.__uploadFiles),
		addFiles: i((t) => e(o, t), [o]),
		uploadFile: i(async (e) => await n(o, e), [o]),
		uploadAllFiles: i(async () => await t(o), [o]),
		removeFile: i((e) => {
			o.removeUploadFile(e);
		}, [o]),
		clearFiles: i(() => {
			o.clearUploadFiles();
		}, [o]),
		validateFile: i((e) => r(e), [])
	};
}
//#endregion
export { o as useCopilotFileUpload };
